import type { TournamentEntry } from "@mixitone/models";
import { ApplicationView } from "@mixitone/mvc";
import clsx from "clsx";

const EntryNames = ({ entry, className }: { entry: TournamentEntry; className?: string }) => {
  return (
    <span className={clsx(className, { "line-through": entry.withdrawn })}>
      {entry.shortNames.join(" & ")}
    </span>
  );
};

export default ApplicationView(EntryNames);
